import React from 'react';
import { BedIcon, BathIcon, ParkingIcon } from '@domain-group/fe-co-icon';
import * as styles from './child-list.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var ChildList = _ref => {
  var _ref$listings = _ref.listings,
    listings = _ref$listings === void 0 ? [] : _ref$listings,
    layout = _ref.layout;
  var renderFeatureIcon = (SelectedIcon, value, title) => ___EmotionJSX("span", {
    css: styles.itemFeature
  }, ___EmotionJSX("span", {
    css: styles.itemText
  }, value || '-'), ___EmotionJSX(SelectedIcon, {
    css: styles.itemIcon,
    title: title,
    size: "custom"
  }));
  var renderSingleListing = item => {
    var _item$property$types, _item$listing$url;
    var isLand = ((_item$property$types = item.property.types) === null || _item$property$types === void 0 ? void 0 : _item$property$types[0]) === 'LAND';
    var features = [];
    if (isLand) {
      var isValidSize = !!item.property.size && item.property.size > 0;
      features.push(___EmotionJSX("span", {
        css: styles.itemFeatureLand
      }, ___EmotionJSX("span", {
        css: styles.itemSize
      }, "Land"), isValidSize && ___EmotionJSX("span", {
        css: styles.itemSizeValue
      }, item.property.size, "m", ___EmotionJSX("sup", {
        css: styles.itemSizeValueM2
      }, "2"))));
    } else {
      features.push(renderFeatureIcon(ParkingIcon, item.property.cars, 'Parking'));
      features.push(renderFeatureIcon(BathIcon, item.property.baths, 'Bathrooms'));
      features.push(renderFeatureIcon(BedIcon, item.property.beds, 'Bedrooms'));
    }
    return ___EmotionJSX("a", {
      key: item.listing.id,
      css: styles.item,
      href: (_item$listing$url = item.listing.url) !== null && _item$listing$url !== void 0 ? _item$listing$url : undefined
    }, ___EmotionJSX("span", {
      css: styles.itemPrice
    }, item.listing.priceLabel), ___EmotionJSX("span", {
      css: styles.features
    }, features));
  };
  return ___EmotionJSX("div", {
    css: styles.container
  }, layout === 'three-column' && ___EmotionJSX("div", {
    css: styles.title
  }, "Properties in the development"), listings.slice(0, 3).map(item => renderSingleListing(item)));
};